export default __webpack_public_path__ + "static/media/ticket.0de8cca5.gif";